{
    "electro": {
        "movingAvg": 0,
        "mergeAbsThr": 0,
        "keys": [
            "3"
        ],
        "tempo": 340,
        "nloop": 99,
        "instruments": {
            "Perfect Score": {
                "enabled": false,
                "type": "Synth",
                "period": 1,
                "length": 1,
                "volume": 0,
                "attackVelocity": 0.5,
                "oscillator": {
                    "type": "sine"
                },
                "effects": {
                    "Reverb": {
                        "preDelay": 0.1,
                        "decay": 1.5
                    },
                    "AutoWah": {
                        "baseFrequency": 100,
                        "octaves": 6,
                        "sensitivity": 0,
                        "Q": 2,
                        "gain": 2,
                        "follower": {
                            "attack": 0.3,
                            "release": 0.5
                        }
                    },
                    "Reverb": {
                        "decay": 0.5,
                        "preDelay": 0.01
                    }
                }
            },
            "Main Keyboard": {
                "enabled": true,
                "type": "Synth",
                "period": 1,
                "length": 1,
                "volume": 0,
                "attackVelocity": 0.5,
                "oscillator": {
                    "type": "sine"
                },
                "effects": {
                    "Reverb": {
                        "preDelay": 0.1,
                        "decay": 1.5
                    },
                    "AutoWah": {
                        "baseFrequency": 100,
                        "octaves": 6,
                        "sensitivity": 0,
                        "Q": 2,
                        "gain": 2,
                        "follower": {
                            "attack": 0.3,
                            "release": 0.5
                        }
                    },
                    "Reverb": {
                        "decay": 0.5,
                        "preDelay": 0.01
                    }
                }
            },
            "Bass": {
                "enabled": true,
                "type": "FMSynth",
                "period": 8,
                "length": 8,
                "ratioMain": 0.50,
                "volume": 0,
                "attackVelocity": 0.5,
                "oscillator": {
                    "type": "sine"
                }
            },
            "Drums": {
                "enabled": true,
                "type": "MembraneSynth",
                "period": 2,
                "length": 0.5,
                "ratioMain": 0.250,
                "volume": 0,
                "attackVelocity": 0.5,
                "oscillator": {
                    "type": "sine"
                }
            }
        }
    },
    "ambient": {
        "movingAvg": 5,
        "mergeAbsThr": 20,
        "keys": [
            "3"
        ],
        "tempo": 70,
        "nloop": 99,
        "instruments": {
            "Perfect Score": {
                "enabled": false,
                "type": "Synth",
                "period": 1,
                "length": 1,
                "volume": 0,
                "attackVelocity": 0.1,
                "oscillator": {
                    "type": "sine"
                },
                "enveloppe": {
                    "attack": 0.6,
                    "decay": 0.2,
                    "sustain": 0.5,
                    "release": 0.6
                },
                "effects": {
                    "Reverb": {
                        "preDelay": 0.01,
                        "decay": 1.5
                    }
                }
            },
            "Main Keyboard": {
                "enabled": true,
                "type": "Synth",
                "period": 1,
                "length": 5,
                "volume": 2,
                "attackVelocity": 0.1,
                "oscillator": {
                    "type": "sine"
                },
                "enveloppe": {
                    "attack": 5,
                    "decay": 1,
                    "sustain": 0.2,
                    "release": 5,
                    "attackCurve": "sine"
                },
                "effects": {
                    "Reverb": {
                        "preDelay": 0.1,
                        "decay": 1.5
                    },
                    "Chorus": {
                        "frequency": 4,
                        "delayTime": 2.5,
                        "depth": 0.8
                    }
                }
            },
            "Chords": {
                "enabled": true,
                "type": "PolySynth",
                "period": 12,
                "length": 12,
                "volume": -24,
                "attackVelocity": 0.8,
                "triad": [
                    0,
                    4,
                    7
                ],
                "oscillator": {
                    "type": "sine"
                },
                "enveloppe": {
                    "attack": 5,
                    "decay": 1,
                    "sustain": 1,
                    "release": 5,
                    "attackCurve": "sine"
                },
                "effects": {
                    "Reverb": {
                        "preDelay": 0.1,
                        "decay": 1.5
                    },
                    "Chorus": {
                        "frequency": 4,
                        "delayTime": 2.5,
                        "depth": 0.8
                    }
                }
            },
            "Bass": {
                "enabled": true,
                "type": "Synth",
                "period": 8,
                "length": 8,
                "ratioMain": 0.125,
                "volume": -2,
                "attackVelocity": 0.8,
                "oscillator": {
                    "type": "sine"
                },
                "envelope": {
                    "attack": 6,
                    "decay": 6,
                    "sustain": 0.8,
                    "release": 1
                }
            },
            "Drums": {
                "enabled": true,
                "type": "MembraneSynth",
                "period": 2,
                "length": 3,
                "ratioMain": 0.125,
                "volume": 0,
                "attackVelocity": 0.8,
                "oscillator": {
                    "type": "sine"
                }
            }
        }
    }
}